import { Type } from "@scalar/typebox";
const compose = (...args) => {
  return Type.Composite(args);
};
export {
  compose
};
//# sourceMappingURL=compose.js.map
